import { render, staticRenderFns } from "./McSpinner.vue?vue&type=template&id=ce784564"
import script from "./McSpinner.vue?vue&type=script&lang=js"
export * from "./McSpinner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports